"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var service_service_1 = require("src/app/Services/service.service");
var router_1 = require("@angular/router");
var material_1 = require("@angular/material");
var common_1 = require("@angular/common");
var NewPasswordComponent = /** @class */ (function () {
    function NewPasswordComponent(fb, services, location, route, data, dialogRef) {
        this.fb = fb;
        this.services = services;
        this.location = location;
        this.route = route;
        this.data = data;
        this.dialogRef = dialogRef;
        this.newPasswordForm = this.fb.group({
            email: [
                null,
                forms_1.Validators.compose([forms_1.Validators.required, forms_1.Validators.email])
            ],
            password: [
                null,
                forms_1.Validators.compose([forms_1.Validators.required, forms_1.Validators.minLength(5)])
            ],
            passwordConfirm: [null, forms_1.Validators.required]
        }, { validators: exports.registrationFormValidate });
    }
    NewPasswordComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.code = this.data.code; //this.route.snapshot.paramMap.get("code");
        if (this.code && this.code != "") {
            this.services.userService
                .getEmailFromCode(this.code)
                .then(function (r) {
                _this.newPasswordForm.controls["email"].setValue(r);
            })
                .catch(function (e) {
                _this.services.route.navigate([""]).then(function () {
                    _this.services.showError(e);
                });
            });
        }
        else {
            this.services.route.navigate([""]);
        }
    };
    NewPasswordComponent.prototype.isEmailNotValid = function () {
        return (this.newPasswordForm.controls["email"].hasError("required") ||
            this.newPasswordForm.controls["email"].hasError("email"));
    };
    NewPasswordComponent.prototype.getEmailErrorMessage = function () {
        return this.newPasswordForm.controls["email"].hasError("required")
            ? "Email is required"
            : this.newPasswordForm.controls["email"].hasError("email")
                ? "Enter valid email address"
                : "";
    };
    NewPasswordComponent.prototype.isPasswordNotValid = function () {
        return (this.newPasswordForm.controls["password"].hasError("required") ||
            this.newPasswordForm.controls["password"].hasError("minlength") ||
            this.newPasswordForm.hasError("passwordConfirmed"));
    };
    NewPasswordComponent.prototype.getPasswordErrorMessage = function () {
        return this.newPasswordForm.controls["password"].hasError("required")
            ? "Password is required"
            : this.newPasswordForm.controls["password"].hasError("minlength")
                ? "Password must have at 5 chars length."
                : this.newPasswordForm.hasError("passwordConfirmed")
                    ? "Password and Confirmation must be equal."
                    : "";
    };
    NewPasswordComponent.prototype.isPasswordConfirmNotValid = function () {
        var res = this.newPasswordForm.controls["passwordConfirm"].hasError("required") ||
            //  || this.registrationForm.controls['passwordConfirm'].hasError('minlength')
            this.newPasswordForm.hasError("passwordConfirmed");
        console.log("confval: " + res);
        return res;
    };
    NewPasswordComponent.prototype.getPasswordConfirmErrorMessage = function () {
        var res = this.newPasswordForm.controls["passwordConfirm"].hasError("required")
            ? "Password Confirmation is required"
            : // this.registrationForm.controls['passwordConfirm'].hasError('minlength') ? 'Password Confirmation must have at 5 chars length.' :
                this.newPasswordForm.hasError("passwordConfirmed")
                    ? "Password and Confirmation must be equal."
                    : "";
        console.log("confm: " + res);
        return res;
    };
    NewPasswordComponent.prototype.onSubmit = function () {
        var _this = this;
        if (!this.newPasswordForm.invalid) {
            this.services.userService
                .newPassword(this.newPasswordForm.controls["email"].value, this.code, this.newPasswordForm.controls["password"].value, this.newPasswordForm.controls["passwordConfirm"].value, "")
                .then(function (r) {
                _this.dialogRef.close();
                _this.location.go("/");
                _this.services.route.navigate([r]).then(function () {
                    _this.services
                        .showInformation("Your password has been changed successfully!")
                        .afterDismissed()
                        .subscribe(function () {
                        _this.services.showLogin();
                    });
                });
            })
                .catch(function (e) {
                _this.services.showError(e);
            });
        }
    };
    return NewPasswordComponent;
}());
exports.NewPasswordComponent = NewPasswordComponent;
exports.registrationFormValidate = function (control) {
    var p = control.get("password");
    var pc = control.get("passwordConfirm");
    var res = p && pc && pc.value === p.value ? null : { passwordConfirmed: true };
    console.log("passwordConfirmed: " + res);
    console.log("pass: " + p.value + " , pc: " + pc.value);
    return res;
};
